import LanguageService from '../services/language-service';
import RootStore from '../stores/root-store';
import { wrapRoot } from 'mobx-easy';
import RegionService from '../services/region-service';
import RealTimeService from '../services/realtime-service';
import { SharedLocationService } from '../services/shared-location-service';
import { MAP_API_KEY } from '../components/map/map.consts';
import EtaService from '../services/eta-service';
import DirectionService from '../services/direction-service';
import UserLocationService from '../services/user-location-service';
import TokenService from '../services/token-service';
import { CustomerExperienceService } from '../services/customer-experience-service';
import AirbrakeService from '../services/airbrake/airbrake-service';

export interface RootEnv {
	etaService: EtaService;
	langService: LanguageService;
	regionService: RegionService;
	realTimeService: RealTimeService;
	sharedLocationService: SharedLocationService;
	customerExperienceService: CustomerExperienceService;
	directionService: DirectionService;
	userLocationService: UserLocationService;
	googleMapsApiKey: string;
	tokenService: TokenService;
	airbrakeService: AirbrakeService;
}

export interface CreateStoreResult {
	rootStore: RootStore;
	env: RootEnv;
}

export interface CreateStoreOptions {
	regionService: RegionService;
	sharedLocationService: SharedLocationService;
	customerExperienceService: CustomerExperienceService;
	realTimeService: RealTimeService;
	langService: LanguageService;
	etaService: EtaService;
	directionService: DirectionService;
	userLocationService: UserLocationService;
	tokenService: TokenService;
	airbrakeService: AirbrakeService;
}

const createStore = ({
	regionService,
	sharedLocationService,
	customerExperienceService,
	realTimeService,
	langService,
	etaService,
	directionService,
	userLocationService,
	tokenService,
	airbrakeService
}: CreateStoreOptions): CreateStoreResult => {
	const env = {
		etaService,
		regionService,
		realTimeService,
		sharedLocationService,
		customerExperienceService,
		langService,
		directionService,
		tokenService,
		userLocationService,
		airbrakeService,
		googleMapsApiKey: MAP_API_KEY
	};
	const rootStore = wrapRoot({ RootStore, env });

	return {
		rootStore,
		env
	};
};

export default createStore;
